module.exports = __webpack_public_path__ + "static/media/Rockness.40b625b3.otf";